<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex xs12>
        <v-img
          :src="require('../assets/logo.svg')"
          class="my-3"
          contain
          height="200"
        ></v-img>
      </v-flex>

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          Welcome to RentalAware
        </h1>
        <p class="subheading font-weight-regular">
          We offer simple solutions and tools to help you gain insight into your current and prospective rental properties. 
          
        </p>
        <div class="yellow font-weight-bold">
          THIS SITE IS CURRENTLY IN PRE-BETA MODE. FEEL FREE TO POKE AROUND, BUT RESULTS MAY VARY AT THIS POINT. THANKS!
        </div>
        If you want to help test, please create a free account and start using the site.<br/>
        When the site officially launches and we start charging for subscriptions, but you will get a free account to use indefintely.
      </v-flex>

      <v-flex
        mb-5
        xs12
      >
        <h2 class="headline font-weight-bold mb-3">What's next?</h2>

        <v-layout justify-center>
          <a
            v-for="(next, i) in whatsNext"
            :key="i"
            :href="next.href"
            class="subheading mx-3"
          >
            {{ next.text }}
          </a>
        </v-layout>
      </v-flex>

      <v-flex
        xs12
        mb-5
      >
        <h2 class="headline font-weight-bold mb-3">Important Links</h2>

        <v-layout justify-center>
          <a
            v-for="(link, i) in importantLinks"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ link.text }}
          </a>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      importantLinks: [
        {
          text: 'Realtor.com',
          href: 'https://www.realtor.com'
        },
        {
          text: 'Trulia',
          href: 'https://www.trulia.com'
        },
        {
          text: 'Redfin',
          href: 'https://www.redfin.com'
        },
        {
          text: 'Zillow',
          href: 'https://www.zillow.com'
        }
      ],
      whatsNext: [
        {
          text: 'Rental Property Manager',
          href: '/manage'
        },
        {
          text: 'Rental Property Calculator',
          href: '/rentalCalcList'
        },
       {
          text: 'Mortgage Calculator',
          href: '/mortgageCalc'
        }

      ]
    })
  }
</script>

<style>

</style>
